import { createFileRoute } from '@tanstack/react-router';

import { getPage } from '@/lib/content-registry';
import { seoHead } from '@/lib/seo';
import { PlannerBlock } from '@/blocks/control-planner';

export const Route = createFileRoute('/build-planner')({
  validateSearch: (search: Record<string, unknown>) => search,
  head: ({ match }) =>
    seoHead({
      ...getPage('/build-planner')!,
      indexable: Object.keys(match.search).length === 0,
    }),
  component: PlannerBlock,
});
